// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___M_AJM","containerShown":"style__containerShown___Rpifz"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/canvas/ui/components/controls-bottom/style.css
// module id = 1357
// module chunks = 0